import { handleActions } from 'redux-actions';
import { types } from './loyaltyProgram.meta';

export const initialState = {
  default: {
    fetching: false,
    failed: false,
    error: '',
    email: '',
    value: null,
  },
};

const requestSearch = (state, { payload }) => ({
  ...state,
  [payload.formName]: {
    ...initialState.default,
    email: payload.email,
    fetching: true,
  },
});

const requestSearchCompleted = (state, action) => {
  const {
    formName,
    givenName,
    familyName,
    loyaltyTier,
    loyaltyId,
  } = action.payload;

  return {
    ...state,
    [formName]: {
      ...state[formName],
      givenName,
      familyName,
      fetching: false,
      value: { loyaltyTier, loyaltyId },
    },
  };
};

export const ERROR_CODES = {
  NOT_FOUND: 'USER_DOES_NOT_EXIST',
  SERVER_ERROR: 'SERVER_ERROR',
};
const requestSearchFailed = (state, action) => {
  const { formName, code, givenName, familyName } = action.payload;

  return {
    ...state,
    [formName]: {
      ...initialState.default,
      failed: true,
      familyName,
      givenName,
      error:
        code === ERROR_CODES.NOT_FOUND
          ? ERROR_CODES.NOT_FOUND
          : ERROR_CODES.SERVER_ERROR,
    },
  };
};

const clearMemberId = (state, { payload: formName }) => ({
  ...state,
  [formName]: { ...initialState.default },
});

const getValidState = state => {
  const validKeys = Object.keys(state).filter(key => !state[key].failed);

  return validKeys.reduce(
    (result, key) => ({ ...result, [key]: state[key] }),
    {}
  );
};

const clearFailedData = (state, action) => {
  return { ...getValidState(state) };
};

export default handleActions(
  {
    [types.REQUEST_SEARCH_MEMBER_ID]: requestSearch,
    [types.REQUEST_SEARCH_MEMBER_ID_COMPLETED]: requestSearchCompleted,
    [types.REQUEST_SEARCH_MEMBER_ID_FAILED]: requestSearchFailed,
    [types.CLEAR_MEMBER_ID]: clearMemberId,
    [types.CLEAR_FAILED_DATA]: clearFailedData,
  },
  initialState
);
